import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { GetUserHashResult } from './blatout.interface'

@Injectable({
  providedIn: 'root'
})

export class BlatOutServiceApi {

  public url = 'https://fellbeast.fieldcontrol.com.br/blatout'

  public constructor(
    private readonly http: HttpClient
  ) { }

  public async getUserHash(userId: string): Promise<GetUserHashResult> {
    return firstValueFrom(this.http.get<GetUserHashResult>(`${this.url}/users/${userId}`))
  }
}
